import Vue from 'vue'
import SiteStructure from '../tools/site-structure'
import PageCarousel from './tools/PageCarousel'
import ContentManager from './tools/ContentManager'
import EventBus from './../../event-bus'
import ContentBase from './ContentBase'

const CarouselGuide = () => import(/* webpackChunkName: "carousel-guide" */ './tools/CarouselGuide')

Vue.component('CarouselGuide', CarouselGuide)

export default {
  extends: ContentBase,
  name: 'ContentMenuBase',
  beforeCreate () {
    this.pageCarousel = new PageCarousel()
    this.contentManager = new ContentManager(this.pageCarousel)
    // ADD COMPONENTS_LIST to extended component
    // this.contentManager.init(COMPONENTS_LIST)
  },
  mounted () {
    // Events
    let vm = this
    this.eventHandlers = {
      onWindowResize: function (w, h) {
        vm.contentManager.resetOffsetIndex()
        vm.contentManager.updatePageWidth()
        vm.$forceUpdate()
        requestAnimationFrame(function () {
          vm.$forceUpdate()
        })
      },
      onNavCHANGE: function (e) {
        vm.contentManager.changeContent(vm, e.navItem)
        vm.contentManager.updatePageHeight(vm)
      }
    }
    EventBus.$on('onWindowResize', this.eventHandlers.onWindowResize)
    EventBus.$on('Nav.CHANGE', this.eventHandlers.onNavCHANGE)
    EventBus.$once('CAROUSEL_HOWTO_COMPLETE', this.endHowToGuide)
    EventBus.$on('HOWTO_RUNNING', this.howToChangeState)
    EventBus.$on('HOWTO_COMPLETE', this.howToChangeState)
    window.addEventListener('scroll', this.eventHandlers.onScroll)
    // Guide
    // this.guideWatcher = this.$store.state.guideEngine.carousel.getWatcher(this.initHowToGuide)
    // if (!this.$store.state.isMobileOrTablet) {
    //   this.$store.state.guideEngine.carousel.cancel()
    // }
    // Initial State
    this.pageCarousel.init(this, this.contentManager, -SiteStructure.getSelectedItem().index)
    this.contentManager.setIndex(-SiteStructure.getSelectedItem().index, 0)
    this.contentManager.changeContent(this, SiteStructure.getSelectedItem(), true)
    this.contentManager.updatePageHeight(this)
    this.pageHeightInterval = setInterval(this.contentManager.updatePageHeight, 2000, this)
  },
  beforeDestroy () {
    clearInterval(this.pageHeightInterval)
    this.contentManager.destroy()
    this.pageCarousel.destroy()
    EventBus.$off('onWindowResize', this.eventHandlers.onWindowResize)
    EventBus.$off('Nav.CHANGE', this.eventHandlers.onNavCHANGE)
    EventBus.$off('CAROUSEL_HOWTO_COMPLETE', this.endHowToGuide)
    EventBus.$off('HOWTO_RUNNING', this.howToChangeState)
    EventBus.$off('HOWTO_COMPLETE', this.howToChangeState)
    window.removeEventListener('scroll', this.eventHandlers.onScroll)
    this.guideWatcher.destory()
  },
  updated () {
    let vm = this
    window.requestAnimationFrame(function () {
      vm.contentManager.updatePageHeight(vm)
    })
  },
  data () {
    return this.contentManager.data
  },
  methods: {
    initHowToGuide () {
      this.$store.state.guideEngine.howToRunning()
      this.contentManager.initGuide('CarouselGuide')
    },
    endHowToGuide () {
      this.contentManager.removeGuide()
      this.$store.state.guideEngine.howToComplete()
    },
    howToChangeState (guideMode) {
      this.contentManager.data.guideMode = guideMode
    }
  }
}
